module.exports = __webpack_public_path__ + "img/msd.2cad51a4.png";